import lubovnyi_kvadrat from './lubovnyi_kvadrat';

const list = [
  lubovnyi_kvadrat
];

export default list;